import { useAuthStore } from '@services/pinia/AuthStore';

export default async function auth({ to, next }) {
    const store = useAuthStore();

    if (!store.user) {
        await store.getAuthUser();
        if (!store.user) {
            window.location.replace('/login?redirect=' + to.fullPath);
        }
    }

    const permission = (to.meta.permission ? to.meta.permission : []);
    const role = (to.meta.role ? to.meta.role : []);

    let hasPermissionsOrRole = false;
    if (permission.length > 0 || role.length > 0) {
        if (store.user.roles && (store.user.roles.includes('super-admin') || role.some((el) => store.user.roles.includes(el)))) {
            hasPermissionsOrRole = true;
        } else if (store.user.permissions && permission.some((el) => store.user.permissions.includes(el))) {
            hasPermissionsOrRole = true;
        }
    } else {
        hasPermissionsOrRole = true;
    }

    if (!hasPermissionsOrRole) {
        next({ name: 'forbidden' });
    }

    next();
}
